import Button, { ButtonProps } from '@mui/material/Button';

export const TinyButton = ({ children, ...props }: ButtonProps) => {
    return (
        <Button
            {...props}
            sx={{
                padding: '2px 6px',
                minWidth: 'fit-content',
                height: 'fit-content',
                borderRadius: '4px',
                fontSize: '13px',
                ...props.sx,
            }}
        >
            {children}
        </Button>
    );
};
